// extracted by mini-css-extract-plugin
module.exports = {"notice":"RedeemBottomInfo_notice__vsLxg"};